import Tag from "../../../../../fragments/Tag";
import RelatedPatients from "../../../../../patient/details/sidebar/related/RelatedPatients";


export default function DemographicsDetails({classes, activeCase, isProcessed}) {
    return <div className={classes.group}>
        <h3 className={classes.group_header_title}>Demographics Details</h3>

        <div className={classes.demographics_details_inner}>
            <div className={classes.demographics_items}>
                {activeCase.police_report?.moonbird_data?.vehicle?.driver && <div className={classes.demographics_item}>
                    <div className="flex-container">
                        <h4>{activeCase.police_report?.moonbird_data?.vehicle?.driver?.first_name} {activeCase.police_report?.moonbird_data?.vehicle?.driver?.last_name}</h4>
                        <Tag color={'Green'}>Driver</Tag>
                    </div>
                <p className={classes.demographics_item_value}><strong>Date of Birth: </strong>{activeCase.police_report?.moonbird_data?.vehicle?.driver?.dob}</p>
                </div>}
    
                {activeCase.police_report?.moonbird_data?.vehicle?.occupants?.map((item, index) => (
                    <div key={index} className={classes.demographics_item}>
                        <div className="flex-container">
                            <h4>{item.name}</h4>
                            <Tag color={'Orange'}>Passenger</Tag>
                        </div>
                        <p className={classes.demographics_item_value}><strong>Age: </strong>{item.age}</p>
                        <p className={classes.demographics_item_value}><strong>Address: </strong>{item.address}</p>
                    </div>
                ))}
            </div>

            <RelatedPatients showSugestedPatients={true} readOnly={isProcessed} />
        </div>
    </div>
}